import {
  Button,
  Card,
  Dropdown,
  Form,
  FormField,
  Header,
  Icon,
  Image,
  List,
  ListItem,
  Message,
  Tab,
  TabPane
} from "semantic-ui-react"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { voidFn } from "react-range/lib/utils"
import CanadianFlag from "../../../images/canadian_flag.svg"
import InfoIcon from "../../../images/info-Icon.svg"
import VinInfo from "../../../images/vin_info.svg"
import { states } from "../../constants"
import { searchVehicleByPlate, searchVehicleByVin } from "../../../v1/actions/vehicles"
import store from "../../../shared_component/utils/configureStore"
import VehicleInfo from "./VehicleInfo"
import { isCanada } from "../../../v1/helpers/translationHelpers"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"

const AddVehicle = ({ t, user, vehicle }) => {
  const [selectedState, setSelectedState] = useState("")
  const [licensePlate, setLicensePlate] = useState("")
  const [vin, setVin] = useState("")
  const [licenseError, setLicenseError] = useState("")
  const [vinError, setVinError] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showVehicle, setShowVehicle] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    if (vehicle.id) {
      setShowVehicle(true)
    }
  }, [])

  const handleStateChange = (e, { value }) => {
    setSelectedState(value)
  }

  const handleTabChange = (e, { activeIndex }) => {
    setActiveIndex(activeIndex)
    trackFirebaseAnalytics({
      event: activeIndex ? gaJSON.EtoB_select_license_plate_tab : gaJSON.EtoB_select_vin_tab
    })
  }
  const handleSearchAgain = () => {
    setShowVehicle(false)
  }

  const handleLicensePlateChange = (e) => {
    setLicensePlate(e.target.value.toUpperCase())
    if (e.target.value.length > 4) {
      setLicenseError("")
    } else {
      setLicenseError(t("licenseValidationError"))
    }
  }

  const handleVinChange = (e) => {
    setVin(e.target.value.toUpperCase())
    if (e.target.value.length == 17) {
      setVinError("")
    } else {
      setVinError(t("vinValidationError"))
    }
  }

  const handleLicenseSubmit = async () => {
    setIsSubmitting(true)
    const success = await store.dispatch(searchVehicleByPlate(licensePlate, selectedState))
    if (success) {
      setShowVehicle(true)
      setIsSubmitting(false)
    } else {
      setLicenseError(t("licenseError"))
      setIsSubmitting(false)
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_license_submit_error
      })
    }
  }

  const handleVinSubmit = async () => {
    setIsSubmitting(true)
    const success = await store.dispatch(searchVehicleByVin(vin, false))

    if (typeof success === "boolean") {
      setShowVehicle(true)
      setIsSubmitting(false)
    } else {
      if (success && success[0].includes("registered")) {
        setVinError(t("vinError"))
      } else {
        setVinError(t("invalidVinError"))
      }
      setIsSubmitting(false)
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_vin_submit_error
      })
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      window.scrollTo(0, 0)
    }
  }, [showVehicle])

  const panes = [
    {
      menuItem: t("licencePlateTitle"),
      render: () => (
        <TabPane attached={false} className="tab-pane">
          <div>
            <Card fluid className="add-vehicle-info">
              <Image src={InfoIcon} />
              {t("findMyVehicleInfo")}
            </Card>

            <Form>
              <FormField error={licenseError.length > 0}>
                <label>{t("plateNumberLbl")}</label>
                <input
                  icon={{ name: "search", circular: true, link: true }}
                  maxLength={8}
                  placeholder={t("plateNumberPlaceholder")}
                  value={licensePlate}
                  onChange={handleLicensePlateChange}
                />
                {licenseError && (
                  <Message size="mini" negative>
                    {licenseError}
                  </Message>
                )}
              </FormField>
              <FormField>
                <label>{t("licenseState")}</label>
                <Dropdown
                  placeholder={t("selectState")}
                  fluid
                  search
                  selection
                  options={states}
                  value={selectedState}
                  onChange={handleStateChange}
                />
              </FormField>
            </Form>
          </div>
          <div className="action-button">
            <Button
              fluid
              onClick={handleLicenseSubmit}
              loading={isSubmitting}
              disabled={!(licensePlate.length > 4 && selectedState.length) || isSubmitting}
              className="primary-button"
            >
              {t("submit")}
            </Button>
          </div>
        </TabPane>
      )
    },
    {
      menuItem: t("vin"),
      render: () => (
        <TabPane attached={false} className="tab-pane">
          <div>
            <Card fluid className="add-vehicle-info">
              <Image src={InfoIcon} />
              {isCanada(user.country) ? t("findMyVehicleByVin") : t("findMyVehicleInfo")}
            </Card>

            <Form>
              <FormField error={vinError.length > 0}>
                <label>{t("vinLbl")}</label>
                <input
                  placeholder={t("vinPlaceholder")}
                  maxLength={17}
                  value={vin}
                  onChange={handleVinChange}
                />
                {vinError && (
                  <Message size="mini" negative>
                    {vinError}
                  </Message>
                )}
              </FormField>
            </Form>
            <div className="vin-info">
              <label>{t("vinInfoList")}</label>
              <List bulleted>
                <ListItem>{t("vinInfoListItem1")}</ListItem>
                <ListItem>{t("vinInfoListItem2")}</ListItem>
                <ListItem>{t("vinInfoListItem3")}</ListItem>
                <ListItem>{t("vinInfoListItem4")}</ListItem>
              </List>
            </div>

            <Image src={VinInfo} />
            <Header as="h4">
              <Icon name="lock" /> {t("privacy")}
            </Header>
            <p>{t("keepYourVinSecure")}</p>
          </div>
          <div>
            <Button
              fluid
              loading={isSubmitting}
              onClick={handleVinSubmit}
              disabled={vin.length != 17 || isSubmitting}
              className="primary-button"
            >
              {t("submit")}
            </Button>
          </div>
        </TabPane>
      )
    }
  ]

  const openCanadianFlow = () => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_click_canadian_user_flow
    })
  }

  return showVehicle ? (
    <VehicleInfo handleSearchAgain={handleSearchAgain} />
  ) : (
    <Card className="add-vehicle-card" raised={true}>
      <div>
        {false && (
          <Card fluid className="add-vehicle-tile" onClick={openCanadianFlow}>
            <Image src={CanadianFlag} /> {t("canadianResident")}
            <Icon name="right arrow" />
          </Card>
        )}
        {isCanada(user.country) ? (
          panes[1].render()
        ) : (
          <Tab
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
            menu={{ secondary: true }}
            panes={panes}
          />
        )}
      </div>
    </Card>
  )
}

function mapStateToProps(state) {
  let user = state.user || {}
  let vehicle = state.selectedVehicle.selectedVehicle || {}
  return {
    user,
    vehicle
  }
}

export default connect(mapStateToProps)(withTranslation("vehicleDetails")(AddVehicle))
